/**
 * Mock Data for Development
 * Used when API is not available
 */

import type { MissingPlayer, Team } from '@/types';

export const mockPlayers: MissingPlayer[] = [
  {
    id: 'theshy',
    name: '姜承録',
    name_en: 'TheShy',
    position: 'TOP',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643080451615_theshy.png',
    birthdate: '1999-07-24',
    country: '韩国',
    team_2025: 'iG',
  },
  {
    id: 'uzi',
    name: '简自豪',
    name_en: 'Uzi',
    position: 'ADC',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2Fuzi.png',
    birthdate: '1997-04-05',
    country: '中国',
    team_2025: 'BLG',
  },
  {
    id: 'rookie',
    name: '宋义进',
    name_en: 'Rookie',
    position: 'MID',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643080382421_rookie.png',
    birthdate: '1997-03-03',
    country: '韩国',
    team_2025: 'iG',
  },
  {
    id: 'meiko',
    name: '田野',
    name_en: 'Meiko',
    position: 'SUPPORT',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643069746313_meiko.png',
    birthdate: '1998-03-27',
    country: '中国',
    team_2025: 'EDG',
  },
  {
    id: 'karsa',
    name: '洪浩軒',
    name_en: 'Karsa',
    position: 'JUNGLE',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643069668421_karsa.png',
    birthdate: '1998-02-13',
    country: '中国台湾',
    team_2025: 'TES',
  },
  {
    id: 'doinb',
    name: '金泰相',
    name_en: 'Doinb',
    position: 'MID',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643069551089_doinb.png',
    birthdate: '1996-12-30',
    country: '韩国',
    team_2025: 'LNG',
  },
  {
    id: 'zoom',
    name: '张星冉',
    name_en: 'Zoom',
    position: 'TOP',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643069862541_zoom.png',
    birthdate: '1999-01-18',
    country: '中国',
    team_2025: 'JDG',
  },
  {
    id: 'ming',
    name: '史森明',
    name_en: 'Ming',
    position: 'SUPPORT',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643069755314_ming.png',
    birthdate: '1999-03-23',
    country: '中国',
    team_2025: 'RNG',
  },
  {
    id: 'wei',
    name: '魏禹安',
    name_en: 'Wei',
    position: 'JUNGLE',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643069825312_wei.png',
    birthdate: '2001-05-12',
    country: '中国',
    team_2025: 'RNG',
  },
  {
    id: 'knight',
    name: '卓定',
    name_en: 'knight',
    position: 'MID',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643069711421_knight.png',
    birthdate: '2000-07-24',
    country: '中国',
    team_2025: 'TES',
  },
  {
    id: 'jkl',
    name: '喻文波',
    name_en: 'JackeyLove',
    position: 'ADC',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643069611315_jackeylove.png',
    birthdate: '2000-11-18',
    country: '中国',
    team_2025: 'TES',
  },
  {
    id: 'crisp',
    name: '刘青松',
    name_en: 'Crisp',
    position: 'SUPPORT',
    photo_url: 'https://am-a.akamaihd.net/image?resize=375:&f=http%3A%2F%2Fstatic.lolesports.com%2Fplayers%2F1643069504213_crisp.png',
    birthdate: '1999-04-20',
    country: '中国',
    team_2025: 'FPX',
  },
];

export const mockTeams: Team[] = [
  { id: 'team-ig', name: 'iG', name_en: 'Invictus Gaming', founded_year: 2011 },
  { id: 'team-edg', name: 'EDG', name_en: 'EDward Gaming', founded_year: 2014 },
  { id: 'team-fpx', name: 'FPX', name_en: 'FunPlus Phoenix', founded_year: 2017 },
  { id: 'team-jdg', name: 'JDG', name_en: 'JD Gaming', founded_year: 2017 },
  { id: 'team-tes', name: 'TES', name_en: 'Top Esports', founded_year: 2019 },
  { id: 'team-rng', name: 'RNG', name_en: 'Royal Never Give Up', founded_year: 2012 },
  { id: 'team-blg', name: 'BLG', name_en: 'Bilibili Gaming', founded_year: 2018 },
  { id: 'team-lng', name: 'LNG', name_en: 'LNG Esports', founded_year: 2017 },
];

// Get unique teams from mock players
export function getUniqueTeams(players: MissingPlayer[]): string[] {
  const teams = new Set<string>();
  players.forEach((player) => {
    if (player.team_2025) {
      teams.add(player.team_2025);
    }
  });
  return Array.from(teams).sort();
}
